import emailTemplate from './service';
export default {
    emailTemplate
};